import { isLocalURL } from 'next/dist/shared/lib/router/utils/is-local-url';
import Router from 'next/router';
import Quill from 'quill';
import { isValidUrl } from '../../plugins/chat/AgentChatComponent';
import { CUSTOM_ATT_FOR_ANCHOR_IN_RICH_TEXT } from '../constants/richTextEditor';

const BlotInline = Quill.import('blots/inline');

// to catch anchor-tag contains internal-link in rich-text-editor to enable navigation with Next.js router
// thanks to: https://github.com/vercel/next.js/blob/e933e1d211ea16c349898e141d9733b4cd06e3d8/packages/next/client/link.tsx#L149
export const linkClicked: GlobalEventHandlers['onclick'] = (mouseEvent) => {
    mouseEvent.stopPropagation();
    mouseEvent.preventDefault();

    const el = mouseEvent.target as HTMLAnchorElement;
    const { nodeName, href } = el;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === 'A';

    // ignore click for browser’s default behavior
    if (!isAnchorNodeName || !href) return;

    const isAnchorInRichText = el.getAttribute(CUSTOM_ATT_FOR_ANCHOR_IN_RICH_TEXT) === 'true';
    // ignore click for browser’s default behavior
    if (!isAnchorInRichText) return;

    if (!isLocalURL(href)) return window.open(href);

    console.debug('isAnchorInRichText:', isAnchorInRichText, ' will navigate with Next.js router');
    Router.router.push(href);
};

class LinkWithGrispiAttribute extends BlotInline {
    static create(value) {
        const node = super.create();
        node.setAttribute(
            'href',
            isValidUrl(value) || value?.startsWith('mailto:') // allow mailto and valid urls
                ? value
                : isLocalURL(value) && value?.startsWith('/tickets') // allow internal ticket links
                  ? value
                  : 'https://' + value //otherwise add https://
        );
        node.setAttribute(CUSTOM_ATT_FOR_ANCHOR_IN_RICH_TEXT, true);
        node.onclick = linkClicked;
        return node;
    }

    static formats(domNode) {
        return domNode.getAttribute('href');
    }
}

LinkWithGrispiAttribute.blotName = 'link';
LinkWithGrispiAttribute.tagName = 'a';

export default LinkWithGrispiAttribute;
